











































































































import { Component, Vue } from "vue-property-decorator";
import RequestHandler from "@/assets/ts/requestHandler.ts";
import ReportGenerator from "@/components/ReportGenerator.vue";

const RH = new RequestHandler();
@Component({
  components: {
    ReportGenerator
  }
})
export default class Reports extends Vue {
  private reports = {
    dialog: false,
    type: "Employees",
    typesBoxItems: ["Employees", "Billing"]
  };
  private searchTime = new Date();
  private startDate = new Date().toISOString().substr(0, 10);
  private endDate = new Date().toISOString().substr(0, 10);
  private startDatePicker = false;
  private endDatePicker = false;

  private fixMenuRole(refName: string) {
    const label =
      refName === "startDateMenu" ? "Start date picker" : "End date picker";
    this.$nextTick(() => {
      const menu = this.$refs[refName] as any;
      const content = menu?.$refs?.content as HTMLElement;
      if (content && content.getAttribute("role") === "menu") {
        content.setAttribute("role", "dialog");
        content.setAttribute("aria-label", label);
      }
    });
  }

  private printReport() {
    window.print();
  }
}
